import { SingletonFlowchart } from "./singletonFlowchart";
import { GetNewController } from "./factoryController"
import { RemoveSelectionNodes } from "../../nodes/_model/GlobalDecoration"
import { urlMainAPI } from '@/global';

//Ctrl+z//
export const Undo = async  function(that) {
  let undoNodes = await GetUndo();
  if(undoNodes){
    SingletonFlowchart.Memory.clear();
    loadNodes(undoNodes, that.openDialog);
    setMouseWait(true);
    setMouseWait(false);
  }
}

const GetUndo = async function() {
  let [undo, redo, cache] = await getUndoRedo();
  let endUndo = undo.length > 2 ? undo[(undo.length - 2)] : (undo.length > 1 ? undo[1] : undo[0]);

  if(undo.length > 1) redo.push(undo.splice(undo.length - 1, 1)[0]);
  
  RemoveSelectionNodes();
  saveUndoRedo({ undo, redo, cache });
  return endUndo;
};

//Ctrl+y//
export const Redo = async function(that) {
  let redoNodes = await GetRedo();
  if(redoNodes){
    SingletonFlowchart.Memory.clear();
    loadNodes(redoNodes, that.openDialog);
    setMouseWait(true);
    setMouseWait(false);
  }
}

const GetRedo = async function() {
  let [undo, redo, cache] = await getUndoRedo();
  let endRedo = redo.length > 0 ? redo[(redo.length - 1)] : null;
  
  if(endRedo) undo.push(redo.splice(redo.length - 1, 1)[0])

  RemoveSelectionNodes();
  saveUndoRedo({ undo, redo, cache });
  return endRedo;
};

export const Save = async function() {
  let [undo, redo, cache] = await getUndoRedo();

  undo.push(SingletonFlowchart.Memory.getNodesToSave());
  redo = [];
  cache = [];

  saveUndoRedo({ undo, redo, cache });  
};

function setMouseWait(loading){
  if(loading){
    document.querySelector('#svg').style.cursor = "progress"
  }
  else
    document.querySelector('#svg').style.cursor = "crosshair"
}

const loadNodes = (nodes, callback) => {
  if(nodes && nodes.length > 0){
    nodes.forEach(n => {

      let ctr = new GetNewController(n.type, n.areaInfo ? n.areaInfo.name : null);
      if(ctr)
        ctr.loadNode(n, callback)
    })
  }
}

async function saveUndoRedo(undoRedo){
  let url = `${urlMainAPI}/saveundoredo`
  let object = {
    undo : JSON.stringify(undoRedo.undo),
    redo : JSON.stringify(undoRedo.redo),
    cache : JSON.stringify(undoRedo.cache)
  }
  await SingletonFlowchart.axios.post(url, object)
  .catch(console.error); 
}

export const cleanUndoRedo = async function() {
  if(!SingletonFlowchart.axios)  return
  let url = `${urlMainAPI}/cleanundoredo`
  await SingletonFlowchart.axios.get(url)
  .catch(console.error); 
}

const getUndoRedo = async function() {
  if (!SingletonFlowchart.axios) return
  let url = `${urlMainAPI}/getundoredo`
  let operations = {}
  await SingletonFlowchart.axios.get(url)
  .then((res) => {
    operations = res.data;
  })
  .catch();
  let undo = operations.undo;
  let redo = operations.redo;
  let cache = operations.cache;
  undo = undo ? JSON.parse(undo) : new Array()
  redo = redo ? JSON.parse(redo) : new Array()
  cache = cache ? JSON.parse(cache) : new Array()
  
  return [
    undo, 
    redo, 
    cache
  ];
};